/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const paymentMethodSchema = z.enum(['Jobilla Wallet', 'Card', 'Bank Transfer'])

export type PaymentMethodSchema = z.infer<typeof paymentMethodSchema>
